import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/Auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  return next(authService.isAuthenticated() ? req.clone({ headers: req.headers.set("Authorization", `Bearer ${authService.getAuthToken()}`) }) :  req);
};
